export const round2 = (value: number) => Math.round(value * 100) / 100

export const money = (value: number) =>
  `${value.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
